/**
 * webauthn-errors/challenge-race-messages.ts — begin-supersede race code
 *
 * Split out of messages.ts for the 300-line modularity rule, mirroring the
 * master-messages.ts / keypair-binding-messages.ts precedent, and
 * re-exported into SERVER_ERROR_MESSAGES so `resolveWebAuthnError` needs no
 * separate lookup.
 *
 * AC-15 — the begin-supersede race (spec origin trace: five `begin`s / zero
 * finishes on payment-instruction reveal). `beginChallengeRespond` supersedes
 * any prior unconsumed challenge for the same {sessionId, challengeId,
 * action} on every call; a finish racing an EARLIER begin's still-open
 * authenticator dialog now gets this typed code instead of the generic
 * INVALID_CHALLENGE. The client's in-flight guard
 * (client/src/lib/payment-rail/begin-inflight-guard.ts) retries the whole
 * ceremony automatically ONCE on this code — this copy is the fallback shown
 * only if that automatic retry ALSO fails.
 */

import type { WebAuthnUserMessage } from "./types";

export const CHALLENGE_RACE_ERROR_MESSAGES: Record<string, WebAuthnUserMessage> = {
  CHALLENGE_SUPERSEDED: {
    title:       "Request refreshed",
    description: "Your confirmation request was refreshed. Please try again.",
    retryable:   true,
    severity:    "amber",
  },
};
